// Lamp showcase: pick a shade (variant), blend the light-off / light-on renders,
// or switch to an interactive 3D model (model-viewer loads only on first use).
(function () {
  var root = document.getElementById('LampProduct');
  if (!root) return;
  var pictures = root.querySelector('.lp__pictures');
  var pairs = root.querySelectorAll('.lp__pair');
  var designs = root.querySelectorAll('.lp__design');
  var lights = root.querySelectorAll('.lp__light');
  var views = root.querySelectorAll('.lp__view[data-view]');
  var range = document.getElementById('LampRange');
  var label = document.getElementById('LampLabel');
  var env = document.getElementById('LampEnv');
  var price = document.getElementById('LampPrice');
  var idInput = document.getElementById('LampVariantId');
  var model = document.getElementById('LampModel');
  var status = document.getElementById('LampStatus');
  var resetBtn = document.getElementById('LampReset');
  var lightNote = root.querySelector('.lp__lightnote');
  var originalNote = lightNote ? lightNote.textContent : '';
  var current = designs.length ? designs[0].getAttribute('data-variant') : null;
  var level = 0;
  var mode = 'images';
  var viewerReady = null;

  function state() { return level === 0 ? 'LIGHT OFF' : level === 100 ? 'LIGHT ON' : 'RENDERED BLEND'; }

  function loadViewer() {
    if (viewerReady) return viewerReady;
    viewerReady = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = window.LampModelViewerUrl;
      s.onload = function () { customElements.whenDefined('model-viewer').then(resolve); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return viewerReady;
  }

  function render() {
    var name = '', glb = '', isImage = mode === 'images';
    pictures.hidden = !isImage;
    root.querySelector('.lp__stage').classList.toggle('is-3d', !isImage);
    if (model) model.hidden = isImage;
    pairs.forEach(function (p) {
      var on = p.getAttribute('data-variant') === current;
      p.hidden = !on;
      if (on) p.querySelector('.lp__img--on').style.opacity = level / 100;
    });
    designs.forEach(function (d) {
      var on = d.getAttribute('data-variant') === current;
      d.classList.toggle('is-selected', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) {
        name = d.getAttribute('data-name');
        glb = d.getAttribute(mode === 'exploded' ? 'data-glb-exploded' : 'data-glb');
        if (env && d.getAttribute('data-env')) env.textContent = d.getAttribute('data-env');
        if (price) price.textContent = d.getAttribute('data-price');
      }
    });
    lights.forEach(function (l) {
      var on = Number(l.getAttribute('data-light')) === level;
      l.classList.toggle('is-active', on && isImage);
      l.setAttribute('aria-pressed', on ? 'true' : 'false');
      l.disabled = !isImage;
    });
    views.forEach(function (v) {
      var on = v.getAttribute('data-view') === mode;
      v.classList.toggle('is-active', on);
      v.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    range.disabled = !isImage;
    range.value = level;
    if (lightNote) lightNote.textContent = isImage ? originalNote : '3D shows the geometry. Use Images for the light-off / light-on renders.';
    if (label) label.textContent = name.toUpperCase() + ' / ' + (isImage ? state() : mode === 'exploded' ? 'EXPLODED ASSEMBLY' : '3D GEOMETRY');
    if (idInput) idInput.value = current;

    if (!isImage && model && glb) {
      status.textContent = 'Loading 3D…';
      loadViewer().then(function () {
        if (model.getAttribute('src') !== glb) model.setAttribute('src', glb);
        model.cameraTarget = mode === 'exploded' ? '0m 0.23m 0m' : '0m 0.135m 0m';
        model.cameraOrbit = '30deg 72deg auto';
      }).catch(function () {
        status.textContent = '3D could not load. Switch back to Images.';
      });
    } else if (status) {
      status.textContent = '';
    }
  }

  if (model) {
    model.addEventListener('load', function () { status.textContent = ''; });
    model.addEventListener('error', function () { status.textContent = '3D could not load. Switch back to Images.'; });
  }

  designs.forEach(function (d) {
    d.addEventListener('click', function () { current = d.getAttribute('data-variant'); render(); });
  });
  lights.forEach(function (l) {
    l.addEventListener('click', function () { level = Number(l.getAttribute('data-light')); render(); });
  });
  views.forEach(function (v) {
    v.addEventListener('click', function () { mode = v.getAttribute('data-view'); render(); });
  });
  if (resetBtn) resetBtn.addEventListener('click', function () {
    if (mode === 'model' && model) {
      model.cameraOrbit = '30deg 72deg auto';
      if (model.jumpCameraToGoal) model.jumpCameraToGoal();
    } else { level = 0; render(); }
  });
  range.addEventListener('input', function () { level = Number(range.value); render(); });
  render();
})();
